module.exports = __webpack_public_path__ + "img/god_godsglorynft.5b0b420.png";